import UserContext from 'contexts/UserConext';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Route,
  RouteComponentProps,
  Redirect,
  RouteProps,
  useHistory
} from 'react-router-dom';
import { setHeaderPanelExpand } from 'redux/app/actions';
import { selectAuthError } from 'redux/auth/selectors';
import { currentUser, selectIsAuthenticated } from 'redux/session/selectors';
import { fetchUserStart } from 'redux/user/actions';
import { APP_URL, AUTH_ERR_MSG } from 'types';
import Utils from 'utilities/helper.util';

const AuthRoute: React.FC<
  RouteProps & {
    page: React.FC<RouteComponentProps>;
    requiredRole: string[];
  }
> = ({ page: Page, requiredRole, ...rest }: any) => {
  const history = useHistory();
  const dispatch: any = useDispatch();
  const user: any = useSelector(currentUser);
  const isAuthenticated: boolean = useSelector(selectIsAuthenticated);
  const authError: any = useSelector(selectAuthError);
  const [localUserRole, setLocalUserRole] = useState<any | undefined>();

  useEffect(() => {
    dispatch(fetchUserStart());
    dispatch(setHeaderPanelExpand({ isOpen: false }));
  }, [dispatch]);

  useEffect(() => {
    authError?.message === AUTH_ERR_MSG.USER_ACCEPT_TERMS &&
      history.push(APP_URL.AUTH_USER_TERMS);
    authError?.message === AUTH_ERR_MSG.USER_SESSION_ORGANISATION &&
      history.push(APP_URL.AUTH_MULTI_ORGANISATION);
  }, [history, authError]);

  useEffect(() => {
    user?.role && setLocalUserRole(user.role);
  }, [user]);

  const renderSelectedRoute = () => (
    <Route
      {...rest}
      render={(props: RouteComponentProps) => <Page {...props} />}
    />
  );
  // DEFAULT URL ROUTE
  const renderDefaultRoute = () => (
    <Route
      {...rest}
      render={(props: RouteComponentProps) => (
        <Redirect
          to={{
            pathname: APP_URL.AUTH,
            state: { from: props.location }
          }}
        />
      )}
    />
  );

  const renderAuthenticatedRoute = () => {
    const isUserRoleValid = Utils.isValidUserRole(requiredRole, localUserRole);
    // REDIRECT PAGE BASED ON SELECTION
    if (isUserRoleValid) {
      return renderSelectedRoute();
    } else {
      return renderDefaultRoute();
    }
  };

  const renderUnAuthenticatedRoute = () => (
    <Route
      {...rest}
      render={(props: RouteComponentProps) => (
        <Redirect
          to={{
            pathname: APP_URL.AUTH,
            state: { from: props.location }
          }}
        />
      )}
    />
  );

  return (
    <UserContext.Provider value={localUserRole}>
      {isAuthenticated && !authError
        ? localUserRole && renderAuthenticatedRoute()
        : renderUnAuthenticatedRoute()}
    </UserContext.Provider>
  );
};

AuthRoute.displayName = 'AuthRoute';
export default AuthRoute;
